module.exports = __webpack_public_path__ + "static/media/city-deal-plus.3b279237.png";